import { lmsClient } from "api";
import { head } from "lodash";

const ReceptionSuspend = {};

function buildQuery(params) {
  return Object.entries(params)
    .filter(([_, v]) => v !== null && v !== undefined && v !== "")
    .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
    .join("&");
}

ReceptionSuspend.getReceptionSuspend = function (data) {
  var dataIndex = data.pageIndex || 0;
  var decrementIndex = dataIndex === 0 ? dataIndex : dataIndex - 1;

  const params = {
    pageSize: data.pageSize,
    pageIndex: decrementIndex,
    description: data?.description,
    amountFrom: data?.amountFrom,
    amountTo: data?.amountTo,
    bankAccountId: data?.bankAccountId,
    referenceNo: data?.referenceNo,
    postingDate: data?.postingDate,
  };
  return lmsClient({
    url: `/lms/PenerimaanSuspend/search?${buildQuery(params)}`,
    method: "get",
  });
};

ReceptionSuspend.addReceptionSuspend = function (data) {
  return lmsClient({
    url: `/lms/PenerimaanSuspend/add`,
    method: "post",
    data: data,
  });
};

ReceptionSuspend.fetchApproveSuspend = function (data) {
  return lmsClient({
    url: `/lms/SuspendApprove/ApproveSuspend`,
    method: "put",
    headers: {
      "Content-Type": "application/json",
      "Accept": "application/json",
      "x-requestId": data?.id,
    },
    data: data?.data,
  });
};

ReceptionSuspend.fetchRejectSuspend = function (data) {
  return lmsClient({
    url: `/lms/PenerimaanSuspend/RejectedSuspend`,
    method: "put",
    headers: {
      "Content-Type": "application/json",
      "Accept": "application/json",
      "x-requestId": data?.id,
    },
    data: data?.data,
  });
};

export default ReceptionSuspend;
